import type { LocalizedLink } from "@slfinrtl/ui-bff-routes"
import type { OpenListingModalProps } from "src/hooks"

export const openListing = (
	links: LocalizedLink[] | undefined,
	openListingModal: (props: OpenListingModalProps) => void,
	onOpenListing: () => void,
) => {
	if (!links || links.length === 0) {
		return
	}
	onOpenListing()

	if (links.length === 1) {
		window.open(links[0].url, "_blank")
	} else {
		openListingModal({ links })
	}
}
